module.exports = __webpack_public_path__ + "img/feat3.656bf06d.png";